<template>
  <div>
    <!-- BEGIN panel -->
    <div class="card  border-0 mb-3">
      <TaskShow :task="task" />
      <div class="card-footer">
        <div class="justify-content-end" style="display: flex;justify-content: right;">
          <div>
            <button @click="$router.push(`/task/${id}/edit`);" class="btn btn-white btn-xs me-2">Редактировать</button>
            <button @click="removeTask(id)" class="btn btn-white btn-xs">Удалить</button>
          </div>
        </div>
      </div>
    </div>
    <ModChat :task="task" />
    <!-- END panel -->
  </div>
</template>


<script>
import HTTP from "../http";
import {show_error, show_message} from "../message";

export default {
  data() {
    return {
      id: 0,
      mes: "",
      task: {link: 'link'},
      jobs: [{messages: []}],
      status: "ACCEPTED"
    };
  },

  created() {
    this.id = this.$route.params.id
  },


  mounted() {
    this.fetchData();
    window.eventBus.$on('admin.chat.update', (id) => {
      console.log('id', id)
      this.fetchData();
    })
  },


  methods: {
    removeTask(id) {
      if (confirm("Вы уверены? ")) {
        HTTP()
          .delete("v2/task/" + id)
          .then((response) => {
            console.log(response);
            show_message(this.$notify, response.data);
            this.fetchData();
          })
          .catch((error) => {
            show_error(this.$notify, this.$refs.form, error.response.data)
          });
      }
      return;
    },
    fetchData() {
      this.loading = true;
      this.$insProgress.start();
      HTTP()
        .get(`/task/${this.id}?status=REVIEW`)
        .then((resp) => {

          this.task = resp.data.task
          this.jobs = resp.data.jobs
          console.log('TaskShow:resp', resp.data.jobs)
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
        });
    },
    jobUpdate(status, task_id, user_id) {
      this.loading = true;
      this.$insProgress.start();
      HTTP()
        .put(`/job/${this.id}`, {status, message: this.mes, task_id, user_id})
        .then((resp) => {
          console.log('resp', resp)
          this.mes = ''
          this.fetchData()
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
        });
    },
  }
}
</script>


<style>
.task-href {
  cursor: pointer;
  text-decoration: none;
  color: var(--bs-body-color);
}

.task-href:visited {
  color: var(--bs-body-color);
}

.task-href:hover {
  color: var(--bs-body-color);
}
</style>